import { type ReactElement } from 'react';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const paramsSchema = z.object({
  strategyId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute(
  '/_authenticated/wizard/campaigns/$strategyId',
)({
  params: {
    parse: (raw) => paramsSchema.parse(raw),
    stringify: ({ strategyId }) => ({ strategyId: String(strategyId) }),
  },
  staticData: {
    title: 'route.wizard_campaigns.title',
    messageContext: { context_type: 'wizard', idParam: 'strategyId' },
  },
  component: CampaignsLayout,
});

function CampaignsLayout(): ReactElement {
  return <Outlet />;
}
